import { EventEmitter } from "events";
import "whatwg-fetch";
import sessionStore from "./SessionStore";
import { checkStatus, errorHandler } from "./helpers";

class BandStore extends EventEmitter {
  getAll(search, pageSize, offset, callbackFunc) {
    fetch("/api/band?limit="+pageSize+"&offset="+offset+"&search="+encodeURIComponent(search), {headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        if (typeof(responseData.result) === "undefined") {
          callbackFunc(0, []);
        } else {
          callbackFunc(responseData.totalCount, responseData.result);
        }
      })
      .catch(errorHandler);
  } 

  getBand(bandID, callbackFunc) {
    fetch("/api/band/"+bandID, {headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  createBand(band, callbackFunc) {
    fetch("/api/band", {method: "POST", body: JSON.stringify(band), headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  updateBand(bandID, band, callbackFunc) {
    fetch("/api/band/"+bandID, {method: "PUT", body: JSON.stringify(band), headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  deleteBand(bandID, callbackFunc) {
    fetch("/api/band/"+bandID, {method: "DELETE", headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

}

const bandStore = new BandStore();

export default bandStore;



// WEBPACK FOOTER //
// ./src/stores/BandStore.js